import {PlatformNavbarMenuItem} from "@flexinet/ui-components";
import {v4 as uuidv4} from 'uuid';
import {
    AiOutlineAppstore,
    AiOutlineBarChart,
    AiOutlineClockCircle,
    AiOutlineDollarCircle,
    AiOutlineExperiment,
    AiOutlineFileDone,
    AiOutlineFileText,
    AiOutlineHome,
    AiOutlineSetting
} from 'react-icons/ai'
import {MdOutlineBusinessCenter} from "react-icons/md";
import {rbacActions} from "../../../config/rbac/actions.ts";

export const getMenuItems = () => {

    return [
        {
            id: uuidv4(),
            link: '/dashboard',
            label: 'Dashboard',
            leftSection: <AiOutlineHome/>,
            rbac: rbacActions.ViewDashboard,
        }, {
            id: uuidv4(),
            link: '/subscriptions',
            label: 'Subscriptions',
            leftSection: <AiOutlineClockCircle/>,
            rbac: rbacActions.ListSubscriptions,
        }, {
            id: uuidv4(),
            link: '/invoices',
            label: 'Invoices',
            leftSection: <AiOutlineFileDone/>,
            rbac: rbacActions.ListInvoices,
        }, {
            id: uuidv4(),
            link: '/customers',
            label: 'Customers',
            leftSection: <MdOutlineBusinessCenter/>,
            rbac: rbacActions.ListCustomers,
        }, {
            id: uuidv4(),
            link: '/products',
            label: 'Products',
            leftSection: <AiOutlineAppstore/>,
            rbac: rbacActions.ListProducts,
        }, {
            id: uuidv4(),
            link: '/payment-intents',
            label: 'Payment Intents',
            leftSection: <AiOutlineDollarCircle/>,
            rbac: rbacActions.ListPaymentIntents,
        }, {
            id: uuidv4(),
            link: '/setup-intents',
            label: 'Setup Intents',
            leftSection: <AiOutlineSetting/>,
            rbac: rbacActions.ListSetupIntents,
        }, {
            id: uuidv4(),
            link: '/payment-flow-tester',
            label: 'Flow Tester',
            leftSection: <AiOutlineExperiment/>,
            rbac: rbacActions.ViewDashboard,
        }, {
            id: uuidv4(),
            label: 'Reports',
            leftSection: <AiOutlineBarChart/>,
            rbac: rbacActions.ListReportRuns,
            links: [
                {
                    id: uuidv4(),
                    link: '/report-types',
                    label: 'Report Types',
                    leftSection: <AiOutlineFileText/>,
                    rbac: rbacActions.ListReportTypes,
                },
                {
                    id: uuidv4(),
                    link: '/report-runs',
                    label: 'Report Runs',
                    leftSection: <AiOutlineBarChart/>,
                    rbac: rbacActions.ListReportRuns,
                },
            ],
        }] as PlatformNavbarMenuItem[];

};

